<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="productName" label="物料信息">
          <el-input
            v-model="listForm.productName"
            placeholder="请输入名称或编码"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="cyan" icon="el-icon-search" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10" style="margin-top: 10px !important">
      <el-col :span="1.5" class="add-btn">
        <el-button type="primary" icon="el-icon-s-tools" @click="handleAdd"
          >统一设置预警值</el-button
        >
      </el-col>
    </el-row>
    <el-table :data="list" border style="width: 100%" v-loading="loading">
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productName"
        min-width="150"
        label="物料名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="productCode"
        min-width="120"
        label="物料编号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="warningFlag"
        min-width="120"
        label="预警设置"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.warningFlag == 0">否</span>
          <span v-if="scope.row.warningFlag == 1">是</span>
        </template>
      </el-table-column>
      <el-table-column min-width="120" label="轻度预警" align="center">
        <template slot-scope="scope">
          <slot v-for="(item, index) in scope.row.minMaxDomainParams">
            <span
              v-if="item.name == 1 && scope.row.warningFlag == 1"
              :key="index"
              >{{ item.min }} &lt;​​​ N ​≤ {{ item.max }}</span
            >
          </slot>
        </template>
      </el-table-column>
      <el-table-column min-width="120" label="中度预警" align="center">
        <template slot-scope="scope">
          <slot v-for="(item, index) in scope.row.minMaxDomainParams">
            <span
              v-if="item.name == 2 && scope.row.warningFlag == 1"
              :key="index"
              >{{ item.min }} &lt;​​​ N ​≤ {{ item.max }}</span
            >
          </slot>
        </template>
      </el-table-column>
      <el-table-column min-width="120" label="严重预警" align="center">
        <template slot-scope="scope">
          <slot v-for="(item, index) in scope.row.minMaxDomainParams">
            <span
              v-if="item.name == 3 && scope.row.warningFlag == 1"
              :key="index"
              >{{ item.min }} &lt;​​​ N ​≤​ {{ item.max }}</span
            >
          </slot>
        </template>
      </el-table-column>
      <el-table-column min-width="120" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="editBtn(scope.row)"
            >修改预警值</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="800px"
      @close="handleClose"
    >
      <div class="dialog-name">所有物料统一设置预警值</div>
      <div class="dialog-tips1">N为销售区域外扫码次数</div>
      <div class="dialog-check">
        <el-checkbox-group v-model="addForm.warningFlag">
          <el-checkbox
            true-label="0"
            false-label="1"
            label="不预警"
          ></el-checkbox>
          <span class="dialog-tips2">勾选后表示产品窜货后无预警提示。</span>
        </el-checkbox-group>
      </div>
      <el-form
        @submit.native.prevent
        :model="addForm"
        :rules="rules"
        ref="addForm"
        label-width="120px"
        class="dialog-box"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="item.title"
              v-for="(item, index) in addForm.minMaxDomainParams"
              :key="index"
            >
              <el-input
                v-model="item.min"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></el-input
              >&nbsp;&nbsp;&nbsp;&lt;​​​&nbsp;&nbsp;&nbsp;N&nbsp;&nbsp;&nbsp;≤&nbsp;&nbsp;&nbsp;
              <el-input
                v-model="item.max"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span :class="['put-label', 'label-' + index]">{{
                item.title
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="desc">
        如：轻度预警 10&lt;​​​ N ≤ 20 代表域外扫码次数在该区间内则视为轻度预警
      </div>
      <div slot="footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveBtn()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getfeelingPage, savePath, saveSinglePath } from "@/common/api.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      listForm: {
        pageSize: 10,
        pageNum: 1,
        productName: "",
      },
      total: 0,
      list: [],
      title: "统一设置预警值",
      dialogEdit: false,
      addForm: {
        productId: "",
        warningFlag: "1",
        minMaxDomainParams: [
          {
            title: "轻度预警",
            shortName: "轻度",
            name: "1",
            min: null,
            max: null,
          },
          {
            title: "中度预警",
            shortName: "中度",
            name: "2",
            min: null,
            max: null,
          },
          {
            title: "重度预警",
            shortName: "重度",
            name: "3",
            min: null,
            max: null,
          },
        ],
      },
      rules: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      getfeelingPage(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleAdd() {
      this.title = "统一设置预警值";
      this.dialogEdit = true;
    },
    editBtn(row) {
      if (row.minMaxDomainParams && row.minMaxDomainParams.length > 0) {
        let array = [];
        for (let k = 0; k < row.minMaxDomainParams.length; k++) {
          if (row.minMaxDomainParams[k].name == "1") {
            array.push({
              title: "轻度预警",
              shortName: "轻度",
              name: "1",
              min: row.minMaxDomainParams[k].min,
              max: row.minMaxDomainParams[k].max,
            });
          } else if (row.minMaxDomainParams[k].name == "2") {
            array.push({
              title: "中度预警",
              shortName: "中度",
              name: "2",
              min: row.minMaxDomainParams[k].min,
              max: row.minMaxDomainParams[k].max,
            });
          } else {
            array.push({
              title: "重度预警",
              shortName: "重度",
              name: "3",
              min: row.minMaxDomainParams[k].min,
              max: row.minMaxDomainParams[k].max,
            });
          }
        }
        array = array.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        this.addForm.minMaxDomainParams = array;
      } else {
        this.addForm.minMaxDomainParams = [
          {
            title: "轻度预警",
            shortName: "轻度",
            name: "1",
            min: null,
            max: null,
          },
          {
            title: "中度预警",
            shortName: "中度",
            name: "2",
            min: null,
            max: null,
          },
          {
            title: "重度预警",
            shortName: "重度",
            name: "3",
            min: null,
            max: null,
          },
        ];
      }
      this.title = "修改阀值";
      this.dialogEdit = true;
      this.addForm.productId = row.productId;
      this.addForm.warningFlag = row.warningFlag||'1';
    },
    saveBtn() {
      if (this.addForm.productId) {
        saveSinglePath(this.addForm).then((res) => {
          if (res.errorCode == 200) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.getPageList();
            this.dialogEdit = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        savePath(this.addForm).then((res) => {
          if (res.errorCode == 200) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.dialogEdit = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleClose() {
      this.addForm = {
        productId: "",
        warningFlag: "1",
        minMaxDomainParams: [
          {
            title: "轻度预警",
            shortName: "轻度",
            name: "1",
            min: null,
            max: null,
          },
          {
            title: "中度预警",
            shortName: "中度",
            name: "2",
            min: null,
            max: null,
          },
          {
            title: "重度预警",
            shortName: "重度",
            name: "3",
            min: null,
            max: null,
          },
        ],
      };
    },
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.listForm = {
          pageSize: 10,
          pageNum: 1,
          productName: "",
        };
        this.$refs["listForm"].resetFields();
        this.getPageList();
      });
    },
  },
  created() {},
  mounted() {
    this.getPageList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .dialog-box /deep/.el-input {
    display: inline-block;
    width: 25%;
  }
  .put-label {
    padding: 5px 50px !important;
    margin-left: 20px;
    color: #ffffff;
  }
  .label-0 {
    background-color: #fac68a;
  }
  .label-1 {
    background-color: #b06822;
  }
  .label-2 {
    background-color: #d4011c;
  }
  .dialog-name {
    font-size: 18px;
    text-indent: 50px;
  }
  .dialog-tips1 {
    margin-top: 10px;
    text-indent: 50px;
  }
  .dialog-tips2 {
    font-size: 12px;
    margin-left: 20px;
  }
  .dialog-check {
    margin-left: 50px;
    margin-top: 10px;
    margin: 12px 0 20px 50px;
  }
  .desc {
    margin-top: 30px;
    margin-left: 50px;
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;

    .el-select {
      width: 100%;
    }
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .code-detail .el-form-item {
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/feelingInfo/feelingSet.vue